export const custom_headers = {
  x_team_id: 'x-team-id',
};
